import lightLogo from '../image/lightLogo.svg';

interface ContainerProps {
  height: string;
}

const HeaderStyle1: React.FC<ContainerProps> = ({ height }) => {
  return (
    <div className={`${height} justify-center flex`}>
      <img src={lightLogo} width={220} />
    </div>
  );
};

export default HeaderStyle1;
